import Login from "./login.jsx";
import ForgetPassword from "./forget.jsx";
//import ResetPassword from "./reset-password.jsx";
//import OutlookCallback from "./outlook-callback.jsx";

export { ForgetPassword };
//export { ResetPassword, ForgotPassword, OutlookCallback };
export default Login;
